document.addEventListener('DOMContentLoaded', () => {
  const navToggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', () => {
      const open = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
    });
  }
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => btn.addEventListener('click', () => {
      const delta = Number(btn.dataset.delta || 0);
      input.value = Math.max(0, Number(input.value || 0) + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });
});
